export const translations = [
  {
    locale: "en",
    Home: {
      button_1: "Register as a Reseller",
      button_2: "Login",
      button_3: "Submit Request",
      button_4: "Ask for a demo",
      button_5: "Become a client",
      button_6: "Contact our sales representative",
      tooltip_1:
        "Register your contact information and one of our representatives will get in touch with you",
      tooltip_2: "Request a demo from our sales representatives",
      form_1: "Register as a Reseller",
      form_2: "Name and Surname",
      form_3: "Company",
      form_4: "Email",
      form_5: "Phone",
      form_6: "Position in the Company",
      form_7: "Select an option",
      form_8: "Business Area",
      form_9: "Loading...",
      form_10: "A connection error has occurred.",
      form_11: "Please check your connection and try again.",
      form_12: "Your request has been successfully submitted,",
      form_13: "we will contact you soon!",
      form_14: "An error has occurred with the data.",
      form_15: "The email you are trying to register is already in use.",
      header_1: "Who is it for?",
      header_2: "Intelligence",
      header_3: "Features",
      header_4: "Mission",
      header_5: "Experience",
      header_6: "FAQ's",
      header_7: "Our Resellers",
      seccion1_1: "Track. Analyze.",
      seccion1_2: "Grow.",
      seccion1_3:
        "Shelf-e is an AI-driven online Digital Shelf Analytics platform. ",
      seccion1_4:
        "We offer daily downloads of thousands of products in thousands of ",
      seccion1_5:
        "categories from a customizable selection of retailers, with option ",
      seccion1_6:
        "to hundreds of stores for a  greater regional visibility. ",
      seccion1_7: " Monitor Performance. Gain Insights. Drive Growth.",
      stat_products: "products/day",
      stat_retailers: "retailers",
      stat_categories: "categories",
      hero_footnote: "No annual contracts · Onboarding in 48h · English support",
      retailers_label: "We monitor 25+ retailers across LATAM & USA",
      landing_eyebrow: "Digital Shelf Analytics for LATAM",
      landing_h1: "Stop guessing what your competitors are doing on the digital shelf",
      landing_sub:
        "Track prices, promotions, availability and position for your brand and your competitors across 25+ LATAM retailers — updated daily.",
      landing_bullet_1: "Competitor prices & promotions, every day",
      landing_bullet_2: "Stockout and phantom-product alerts before you lose sales",
      landing_bullet_3: "Share of Shelf and position by retailer and category",
      landing_bullet_4: "Actionable reports for RGM and Trade Marketing teams",
      landing_form_title: "Request your free demo",
      landing_form_sub: "Our sales team will contact you shortly to schedule your demo.",
      landing_trust_label: "Data from LATAM's leading retailers",
      landing_cta_button: "Get my demo",
      landing_privacy:
        "By submitting, you agree to be contacted by the Shelf-e sales team. We never share your information with third parties.",
      seccion25_1: "Are you a brand selling on e-commerce platforms?",
      seccion25_2:
        "Stay ahead of the game. Increase your visibility, enhance your efficiency, and gain a clearer view of your competition.",
      seccion26_1: "Our purpose is",
      seccion26_2: "to provide actionable intelligence to",
      seccion26_3: "our customers",
	  diagram_sub:"for brands who sell on e-commerce portals",
      seccion26_4: "Operational intelligence",
      seccion26_5: "Market intelligence",
      seccion26_6: "Price Matching",
      seccion26_7: "eCommerce Price Competition",
      seccion26_8: "Content Score",
      seccion26_9: "Product Availability",
      seccion26_10: "Share of Innovation",
      seccion26_11: "Market Price Index",
      seccion26_12: "Share of Shelf",
      seccion26_13: "Share of Promotion",
      seccion26_14: "Region Price Index",
      seccion2_1: "Who is Shelf-e for?",
      seccion2_2: "CPGs selling on major retailer’s e-commerce portals",
      seccion2_3:
        "Shelf-e provides companies with the power to explore and understand the behavior of e-commerce portals through analysis of the 5Ps of Retail: Product, Price, Promotion, Position, and Place.",
      seccion2_4:
        "Companies specialized in products/services/consulting for the retail sector",
      seccion2_5:
        "Shelf-e can be the perfect addition to your portfolio in order to help position your clients in the world of e-commerce.",
      seccion2_6: "Sign up as a reseller",
      seccion3_1: "Our Resellers",
      seccion3_2: "Interested in becoming a reseller? Resellers:",
      seccion3_3: "Provide the first line of client customer service",
      seccion3_4:
        "Are in charge of finding new customers and of maintaining the commercial relationship",
      seccion3_5: "Are in charge of customer onboarding",
      seccion3_6:
        "Optionally are in charge of Level 1 support services according to our SLA",
      seccion3_7: "",
      seccion4_1: "Discover Shelf-e",
      slide_1_title: "Landing Page",
      slide_1_sub: "Your command center: real-time KPIs across all retailers at a glance.",
      slide_2_title: "Price Matching",
      slide_2_sub: "Compare your prices vs. competitors across every retailer simultaneously.",
      slide_3_title: "Historical Price Matching",
      slide_3_sub: "Track price evolution over time and detect market trends before they impact you.",
      slide_4_title: "Price Matching — Product Table",
      slide_4_sub: "SKU-level detail: every product, every retailer, every price in one table.",
      slide_5_title: "Notifications",
      slide_5_sub: "Instant alerts when prices, availability or positions change significantly.",
      slide_6_title: "Data Download Wizard",
      slide_6_sub: "Schedule and automate your data exports in a few clicks.",
      slide_7_title: "Product Catalog Management",
      slide_7_sub: "Organize your product master data and keep it clean across all portals.",
      slide_8_title: "Product Visibility Index",
      slide_8_sub: "Measure how discoverable your SKUs are vs. the competition on the digital shelf.",
      slide_9_title: "Regional Product Availability",
      slide_9_sub: "Identify stockout hotspots by region, store or retailer — before they cost you sales.",
      slide_10_title: "Price Dynamics by Retailer",
      slide_10_sub: "See how each retailer moves prices daily and spot pricing wars as they happen.",
      slide_11_title: "Price Index",
      slide_11_sub: "Compare your brand price index against competitors across categories and weeks.",
      slide_12_title: "Share of Innovation",
      slide_12_sub: "Track new SKU launches by brand and measure your share of innovation weekly.",
      slide_13_title: "Retailer Price War Observatory",
      slide_13_sub: "Detect price competition between retailers and understand who is winning.",
      slide_14_title: "Out-of-Stock Analysis",
      slide_14_sub: "Full visibility of digital stockouts: by brand, retailer, category and trend.",
      seccion5_1: "Our Mission",
      seccion5_2:
        "Provide accurate and valuable information about prices, promotions, products, positioning, and supply, helping brands to empower and understand the complex dynamics of e-commerce.",
      seccion6_1: "Experience",
      seccion6_2: "Shelf-e was created from the merge of a",
      seccion6_3: "technology savvy team with a team of experts",
      seccion6_4: "in solutions for the retail sector. We brought our",
      seccion6_5: "experience and knowledge together to create an",
      seccion6_6: "innovative and client-oriented solution  based on",
      seccion6_7: "data from major electronic marketplaces, including",
      seccion6_8: " MercadoLibre, Amazon, Walmart, Bodega, Chedraui,",
      seccion6_9: "Rappi, and more.",
      footer_1: "Shelf analytics online to achieve the perfect digital store",
      footer_2: "About Us",
      footer_3: "Who is it for?",
      footer_4: "Intelligence",
      footer_5: "Features",
      footer_6: "Mission",
      footer_7: "Experience",
      footer_8: "Blog",
      footer_9: "Contacts",
      footer_10: "Social Media",
      footer_11: "All rights reserved",
    },
  },
  {
    locale: "es",
    Home: {
      button_1: "Registrarse como Reseller",
      button_2: "Iniciar",
      button_3: "Enviar Solicitud",
      button_4: "Solicita una Demo",
      button_5: "¿Quieres ser cliente?",
      button_6: "Contacta a nuestro asesor de ventas",
      tooltip_1:
        "Registra tus datos y uno de nuestros asesores te estará contactando",
      tooltip_2: "Solicita una demo a nuestros promotores de ventas",
      form_1: "Inscribirme como Reseller",
      form_2: "Nombre y Apellido",
      form_3: "Empresa",
      form_4: "Correo Electrónico",
      form_5: "Teléfono",
      form_6: "Cargo en la Empresa",
      form_7: "Seleccione un opción",
      form_8: "Área de la Empresa",
      form_9: "Cargando...",
      form_10: "Se ha producido un error de conexión.",
      form_11: "Por favor verifique su conexión e intente nuevamente.",
      form_12: "Su solicitud ha sido enviada correctamente,",
      form_13: "pronto nos pondremos en contacto con Usted.!",
      form_14: "Se ha producido un error con los datos",
      form_15: "El correo que intenta registrar ya está en uso.",
      header_1: "¿A quién va dirigido?",
      header_2: "Inteligencia",
      header_3: "Funcionalidades",
      header_4: "Misión",
      header_5: "Experiencia",
      header_6: "P+F",
      header_7: "Nuestros resellers",
      seccion1_1: "Monitorea. Analiza.",
      seccion1_2: "Crece",
      seccion1_3: "Shelf-e es una plataforma de Shelf Analytics Digital on line.",
      seccion1_4: "Impulsada con IA, realizamos descargas diarias de miles de ",
      seccion1_5: "productos en miles de categorías de una lista configurable de ",
      seccion1_6: "retailers, con opción a cientos de tiendas para mayor visibilidad ",
      seccion1_7: "regional. Empieza a monitorear e impulsa tu crecimiento.",
      stat_products: "productos/día",
      stat_retailers: "retailers",
      stat_categories: "categorías",
      hero_footnote: "Sin contratos anuales · Onboarding en 48h · Soporte en español",
      retailers_label: "Monitoreamos más de 25 retailers en LATAM y USA",
      landing_eyebrow: "Digital Shelf Analytics para LATAM",
      landing_h1: "Deja de adivinar qué hace tu competencia en el anaquel digital",
      landing_sub:
        "Monitorea precios, promociones, disponibilidad y posición de tu marca y tu competencia en más de 25 retailers de LATAM — actualizado todos los días.",
      landing_bullet_1: "Precios y promociones de la competencia, todos los días",
      landing_bullet_2: "Alertas de agotados y productos fantasma antes de perder ventas",
      landing_bullet_3: "Share of Shelf y posición por retailer y categoría",
      landing_bullet_4: "Reportes accionables para equipos de RGM y Trade Marketing",
      landing_form_title: "Solicita tu demo gratuita",
      landing_form_sub: "Nuestro equipo comercial te contactará a la brevedad para coordinar tu demo.",
      landing_trust_label: "Datos de los retailers más importantes de LATAM",
      landing_cta_button: "Quiero mi demo",
      landing_privacy:
        "Al enviar aceptas ser contactado por el equipo comercial de Shelf-e. No compartimos tu información con terceros.",
      seccion2_1: "¿A quién va dirigido?",
      seccion2_2: "CPGs con ventas en retailers en LATAM, Centroamérica y USA",
      seccion2_3:
        " Shelf-e brinda a las empresas el poder de explorar y entender el comportamiento de los e-commerce a través de análisis de las 5Ps del Retail: Producto, Precio, Promoción, Posición y Plaza.",
      seccion2_4:
        "Empresas especializadas en productos /servicios / consultoría para el sector retail",
      seccion2_5:
        "Shelf-e puede ser el complemento perfecto a su portafolio para posicionar a sus clientes en el mundo del e-commerce.",
      seccion2_6: "Inscríbase como reseller",
      seccion25_1: "Eres marca y vendes en e-commerce?",
      seccion25_2:
        "No te quedes atrás y aumenta tu visibilidad, incrementa tu efectividad y entiende a tu competencia",
      seccion26_1: "Nuestro propósito es",
      seccion26_2: "entregar inteligencia accionable a",
      seccion26_3: "nuestros clientes",
	  diagram_sub: "para marcas que venden en portales de e-commerce",
      seccion26_4: "Inteligencia operacional",
      seccion26_5: "Inteligencia de mercado",
      seccion26_6: "Comparación de precios",
      seccion26_7: "Competencia de precios en eCommerce",
      seccion26_8: "Puntuación de contenido",
      seccion26_9: "Disponibilidad de productos",
      seccion26_10: "Participación en la innovación",
      seccion26_11: "Índice de precios de mercado",
      seccion26_12: "Participación en estanterías",
      seccion26_13: "Participación en promociones",
      seccion26_14: "Índice de precios regional",
      seccion3_7: "",
      seccion3_1: "Nuestros resellers",
      seccion3_2: "¿Qué hacen?",
      seccion3_3: "Son la cara de SHELF-E al cliente ",
      seccion3_4:
        "Se encargan de la búsqueda de nuevos clientes y de la relación comercial",
      seccion3_5:
        "Gerencian información requerida para dada de alta de clientes",
      seccion3_6:
        "Pueden ofrecer servicios de soporte Nivel 1 de acuerdo al SLA",
      seccion3_7:
        "Pueden ofrecer servicios adicionales de consultoría o apoyo de gestión de retailers (p.e. carga de catálogos)",
      seccion4_1: "Conoce las funcionalidades de Shelf-e",
      slide_1_title: "Página de Llegada",
      slide_1_sub: "Tu centro de comando: KPIs en tiempo real de todos los retailers en un vistazo.",
      slide_2_title: "Price Matching",
      slide_2_sub: "Compara tus precios vs. la competencia en cada retailer simultáneamente.",
      slide_3_title: "Price Matching Histórico",
      slide_3_sub: "Sigue la evolución de precios en el tiempo y detecta tendencias antes de que te impacten.",
      slide_4_title: "Price Matching — Tabla por Producto",
      slide_4_sub: "Detalle a nivel SKU: cada producto, cada retailer, cada precio en una sola tabla.",
      slide_5_title: "Notificaciones",
      slide_5_sub: "Alertas instantáneas cuando precios, disponibilidad o posiciones cambian significativamente.",
      slide_6_title: "Wizard de Descargas",
      slide_6_sub: "Programa y automatiza tus exportaciones de datos en pocos clics.",
      slide_7_title: "Gestión de Catálogos de Productos",
      slide_7_sub: "Organiza tu maestro de productos y mantenlo limpio en todos los portales.",
      slide_8_title: "Índice de Visibilidad de Productos",
      slide_8_sub: "Mide qué tan visible es cada SKU tuyo vs. la competencia en el anaquel digital.",
      slide_9_title: "Disponibilidad Regional de Productos",
      slide_9_sub: "Identifica quiebres de stock por región, tienda o retailer — antes de que te cuesten ventas.",
      slide_10_title: "Dinámica de Precios por Retailer",
      slide_10_sub: "Ve cómo cada retailer mueve precios diariamente y detecta guerras de precios al instante.",
      slide_11_title: "Índice de Precios",
      slide_11_sub: "Compara el índice de precios de tu marca contra competidores por categoría y semana.",
      slide_12_title: "Share de Innovaciones",
      slide_12_sub: "Rastrea lanzamientos de nuevos SKUs por marca y mide tu share de innovación semanal.",
      slide_13_title: "Observabilidad de Guerra de Precios entre Retailers",
      slide_13_sub: "Detecta la competencia de precios entre cadenas y entiende quién está ganando.",
      slide_14_title: "Análisis de Agotados",
      slide_14_sub: "Visibilidad total de agotados digitales: por marca, retailer, categoría y tendencia.",
      seccion5_1: "Nuestra m​isión",
      seccion5_2:
        "Proporcionarle información precisa y valiosa sobre precios, promociones, productos, posicionamiento y abasto para ayudarle a empoderar su marca y entender la compleja dinámica del e-commerce",
      seccion6_1: "Exper​iencia",
      seccion6_2: "Shelf-e se crea a partir de la fusión de un",
      seccion6_3: "equipo de expertos en tecnología y soluciones",
      seccion6_4: "de datos con un equipo experto en soluciones",
      seccion6_5: "para el sector retail. Hemos llevado nuestra",
      seccion6_6: "experiencia y excelencia al mundo de los datos",
      seccion6_7: "de marketplaces electrónicos, incluyendo",
      seccion6_8: "MercadoLibre, Amazon, Walmart, Bodega",
      seccion6_9: "Aurrera, Chedraui, Rappi y más.",
      footer_1:
        "Shelf analytics on line para lograr la tienda digital perfecta",
      footer_2: "Nosotros",
      footer_3: "¿A quién va dirigido?",
      footer_4: "Inteligencia",
      footer_5: "Funcionalidades",
      footer_6: "Misión",
      footer_7: "Experiencia",
      footer_8: "Blog",
      footer_9: "Contactos",
      footer_10: "Redes Sociales",
      footer_11: "Todos los derechos reservados",
    },
  },
];
